import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Empregador, Funcionario } from '../../api.service';
import { BuscaPesquisavelComponent } from '../../shared/busca-pesquisavel.component';
import { OpcaoAuditoria } from './servico-auditoria-administrativa';

@Component({
  selector: 'app-painel-filtros-auditoria',
  standalone: true,
  imports: [CommonModule, FormsModule, BuscaPesquisavelComponent],
  templateUrl: './painel-filtros-auditoria.component.html'
})
export class PainelFiltrosAuditoriaComponent {
  @Input() empregadores: Empregador[] = [];
  @Input() empregadorSelecionado = '';
  @Input() dataInicial = '';
  @Input() dataFinal = '';
  @Input() tipoSelecionado = '';
  @Input() statusSelecionado = 'sucesso';
  @Input() buscaFuncionario = '';
  @Input() funcionariosFiltrados: Funcionario[] = [];
  @Input() limite = 50;
  @Input() tiposAuditoria: OpcaoAuditoria[] = [];
  @Input() statusAuditoria: OpcaoAuditoria[] = [];
  @Input() rotuloFuncionario: (item: unknown) => string = () => '';
  @Input() detalheFuncionario: (item: unknown) => string = () => '';

  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() dataInicialChange = new EventEmitter<string>();
  @Output() dataFinalChange = new EventEmitter<string>();
  @Output() tipoSelecionadoChange = new EventEmitter<string>();
  @Output() statusSelecionadoChange = new EventEmitter<string>();
  @Output() buscaFuncionarioChange = new EventEmitter<string>();
  @Output() selecionarFuncionario = new EventEmitter<unknown>();
  @Output() abrirModalFuncionario = new EventEmitter<void>();
  @Output() limiteChange = new EventEmitter<number>();
}
